import * as Types from './SupplierActionTypes';
import * as SupplierService from '../../../services/SupplierService';

export const createSupplierAction = (suppliers) => {
    return { type: Types.CREATE_SUPPLIER, payload: {suppliers} };
};

export const getSupplierAction = ( suppliers, supplier_id) => {
    return { type: Types.READ_SUPPLIER, payload: { suppliers, supplier_id} };
};

export const updateSupplierAction = (supplier, id) => {
    return { type: Types.UPDATE_SUPPLIER, payload: {supplier, id} };
};

export const getAllProductSupplierAction = (products, supplier_id) => {
    return { type: Types.GET_PRODUCT_FOR_SUPPLIER, payload: { products, supplier_id } };
};

export const getProductByIdSupplierAction = (products, supplier_id, product_id) => {
    return { type: Types.GET_PRODUCT_BY_ID_FOR_SUPPLIER, payload: { products, supplier_id, product_id } };
};

export const createProductBySupplierAction = (products, supplier_id) => {
    return { type: Types.CREATE_PRODUCT_BY_SUPPLIER, payload: { products, supplier_id} };
};

export const deleteProductBySupplierAction = (supplier_id , product_id) => {
    return { type: Types.DELETE_PRODUCT_BY_SUPPLIER, payload: { supplier_id , product_id} };
};

export const updateProductBySupplierAction = (products, supplier_id, product_id) => {
    return { type: Types.UPDATE_PRODUCT_BY_SUPPLIER, payload: { products, supplier_id, product_id} };
};

export const getSuppliers = () => {
    console.log('get all suppliers ');
    return async (dispatch) => {
        try {
            const suppliers = await SupplierService.getAll();
            dispatch(getSupplierAction(suppliers));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};

export const getAllProducts = (supplier_id = 0) => {
    console.log('get products called with supplier id', supplier_id);
    return async (dispatch) => {
        try {
            const products = await SupplierService.getAllProducts(supplier_id);
            dispatch(getAllProductSupplierAction(products, supplier_id));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};

export const getProductByIdForSupplier = (supplier_id = 0, product_id = 0) => {
    console.log('get products called with supplier id and product id', supplier_id, product_id);
    return async (dispatch) => {
        try {
            const products = await SupplierService.getProductByIdForSupplier(supplier_id, product_id);
            dispatch(getProductByIdSupplierAction(products, supplier_id, product_id));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};

export const createProductSupplier = (supplier_id = 0, product) => {
    return async (dispatch) => {
        console.log('inside createUpdateProduct', product, supplier_id);
        try {
            const createdProduct = await SupplierService.createProductBySupplier(supplier_id, product);
            dispatch(createProductBySupplierAction(createdProduct, supplier_id));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};

export const updateProductSupplier = (supplier_id = 0, product_id = 0, product) => {
    return async (dispatch) => {
        console.log('inside createUpdateProduct', product, supplier_id, product_id);
        try {
            const updatedProduct = await SupplierService.updateProductBySupplier(supplier_id, product_id, product);
            dispatch(updateProductBySupplierAction(updatedProduct, supplier_id, product_id));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};

export const deleteProductBySupplier = (supplier_id = 0, product_id = 0) => {
    console.log('inside deleteproductBySupplier', supplier_id , product_id);
    return async (dispatch) => {
        try {
            await SupplierService.deleteProductBySupplier(supplier_id, product_id);
            dispatch(deleteProductBySupplierAction(supplier_id, product_id));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};

export const createSupplier = (suppliers) => {
    console.log('inside createUpdatesupplier', suppliers);
    return async (dispatch) => {
        try {
            const supplier = await SupplierService.register(suppliers);
            console.log('called');
            dispatch(createSupplierAction(supplier));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};

// export const getSupplierById = (supplier_id = 0) =>{
//     console.log('readCustomer called with id', supplier_id);
//     return async (dispatch) => {
//         return SupplierService.get(supplier_id)
//             .then((supplier, supplier_id) => {
//                 console.log(supplier);
//                 dispatch(getSupplierByIdAction(supplier, supplier_id));
//                 console.log(supplier);
//             })
//             .catch((error) => console.log('Error:', error));
//     };
// };

export const getSupplier = (supplierId = 0) => {
    console.log('readsupplier called with id', supplierId);
    return async (dispatch) => {
        if (supplierId > 0) 
            return SupplierService.get(supplierId)
                .then((supplier) => {
                    dispatch(getSupplierAction(supplier, supplierId));
                })
                .catch((error) => console.log('Error:', error));
        else 
            return SupplierService.getAll()
                .then((supplier) => {
                    dispatch(getSupplierAction(supplier, supplierId));
                })
                .catch((error) => console.log('Error:', error));
    };
};

export const updateSupplier = (supplierId = 0, supplier) => {
    return async (dispatch) => {
        console.log('inside createUpdatesupplier', supplier, supplierId);
        try {
            const updatedSupplier = await SupplierService.update(supplierId, supplier);
            dispatch(updateSupplierAction(updatedSupplier));
        } catch (error) {
            return console.log('Error:', error);
        }
    };
};